import { Box, Typography } from "@mui/material";
import React from "react";
import theme from "../../utils/theme";

const styles = {
  root: {
    // py: 3,
    minHeight: "60vh",
    background: theme.palette.background.paper,
    mb: 8,
  },
  title: {
    // mb: 2,
    background: theme.palette.background.dark,
    color: theme.palette.text.light,
    padding: 2,
    borderRadius: "8px 8px 0 0",
  },
  content: {
    borderRadius: "0 0 8px 8px",
    border: `${theme.palette.grey[300]} 1.5px solid`,
    boxShadow: 1,
    p: 2,
    pb: 5,
    position: "relative",
  },
};

const StageWrapper = ({ children, stageID, stageTitle }) => {
  return (
    <Box id={`stage-${stageID}`} sx={styles.root}>
      <Typography variant="h6" sx={styles.title}>
        Stage {stageID} : {" " + stageTitle}
      </Typography>
      <Box sx={styles.content}>{children}</Box>
    </Box>
  );
};

export default StageWrapper;
